import { FC } from 'react';

import { LinkButton, LinkButtonProps } from '@eluve/components';

type OpenInAdminButtonProps = {
  appointmentId: string;
  tenantId: string;
  size?: LinkButtonProps['size'];
};

export const OpenInAdminButton: FC<OpenInAdminButtonProps> = ({
  appointmentId,
  tenantId,
  size,
}) => {
  const url = `/admin/organizations/${tenantId}/appointments/${appointmentId}`;

  return (
    <LinkButton
      icon={{ name: 'ShieldCheck' }}
      size={size}
      text="Open in Admin Dashboard"
      to={url}
      type="outline"
    />
  );
};
